var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24.25C0 10.3156 10.9156 0 25 0C39.0844 0 50 10.3156 50 24.25C50 38.1844 39.0844 48.5 25 48.5C22.4687 48.5 20.0438 48.1656 17.7625 47.5406C17.3202 47.4175 16.8489 47.4506 16.4281 47.6344L11.4656 49.8281C11.1659 49.9603 10.8383 50.0169 10.5116 49.9929C10.1849 49.9688 9.86914 49.8649 9.59201 49.6902C9.31489 49.5155 9.08491 49.2755 8.92229 48.9911C8.75967 48.7068 8.66939 48.3868 8.65937 48.0594L8.52187 43.6125C8.51238 43.3418 8.44791 43.0759 8.33241 42.8309C8.21691 42.586 8.05277 42.367 7.85 42.1875C2.9875 37.8375 0 31.5375 0 24.25ZM17.3313 19.6906L9.9875 31.3406C9.28438 32.4594 10.6562 33.7187 11.7094 32.9219L19.6 26.9344C19.8595 26.7373 20.1762 26.63 20.5021 26.6289C20.828 26.6278 21.1454 26.7328 21.4062 26.9281L27.2469 31.3094C27.6613 31.6201 28.1356 31.8417 28.6399 31.96C29.1441 32.0784 29.6675 32.091 30.1769 31.997C30.6863 31.9031 31.1707 31.7046 31.5995 31.4142C32.0284 31.1237 32.3925 30.7475 32.6688 30.3094L40.0125 18.6594C40.7187 17.5406 39.3438 16.2813 38.2906 17.0781L30.4 23.0656C30.1405 23.2627 29.8238 23.37 29.4979 23.3711C29.172 23.3722 28.8546 23.2672 28.5937 23.0719L22.7531 18.6875C22.3387 18.3767 21.8644 18.1552 21.3601 18.0368C20.8559 17.9185 20.3325 17.9059 19.8231 17.9998C19.3137 18.0938 18.8293 18.2923 18.4005 18.5827C17.9716 18.8732 17.6075 19.2493 17.3313 19.6875V19.6906Z",
    fill: "#00B2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.750dd34154d23f50e68e0818e203a076.svg";
export { ForwardRef as ReactComponent };